import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "report-post__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post_media = _resolveComponent("post-media")!
  const _component_post_time_bar = _resolveComponent("post-time-bar")!
  const _component_trash_btn = _resolveComponent("trash-btn")!
  const _component_restore_btn = _resolveComponent("restore-btn")!
  const _component_post_toolbar = _resolveComponent("post-toolbar")!
  const _component_post_content = _resolveComponent("post-content")!
  const _component_comments_input = _resolveComponent("comments-input")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: _normalizeClass([_ctx.cssClass, "report-post q-pa-sm"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_post_media, {
        class: "report-post__media",
        "post-id": _ctx.post.id,
        media: _ctx.post.media
      }, null, 8, ["post-id", "media"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_post_time_bar, { post: _ctx.post }, null, 8, ["post"]),
        _createVNode(_component_post_toolbar, {
          post: _ctx.post,
          "notes-btn-title": "Work Product Notes",
          notes: "",
          group: ""
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_trash_btn, {
              "report-post": _ctx.reportPost,
              flat: "",
              round: "",
              onTrashed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('trashed', $event)))
            }, null, 8, ["report-post"]), [
              [_vShow, !_ctx.reportPost.isTrashed]
            ]),
            _withDirectives(_createVNode(_component_restore_btn, {
              "report-post": _ctx.reportPost,
              flat: "",
              round: "",
              onRestored: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('restored', $event)))
            }, null, 8, ["report-post"]), [
              [_vShow, _ctx.reportPost.isTrashed]
            ])
          ]),
          _: 1
        }, 8, ["post"]),
        _createVNode(_component_post_content, {
          post: _ctx.post,
          class: "q-pa-md q-ma-none"
        }, null, 8, ["post"])
      ]),
      _createVNode(_component_comments_input, {
        "report-post": _ctx.reportPost,
        class: "report-post__comments q-mx-md",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:comment', $event)))
      }, null, 8, ["report-post"])
    ]),
    _: 1
  }, 8, ["class"]))
}